import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider, setDisplayFormat } from '@restaurant/api-client';
import { startErrorReporting, startTheme } from '@restaurant/ui';
import '@restaurant/ui/tokens.css';

import { App } from './App';
import { Shell } from './shell';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

// A desk, read up close: the back office's room, its type sizes and targets.
document.documentElement.dataset.room = 'office';
startErrorReporting('platform');
startTheme();

// Dates and numbers in the operator's own language. Money is always given
// its currency explicitly here — every restaurant and invoice carries one —
// so the display currency set here is never what a figure is shown in.
setDisplayFormat({ currency: 'USD', locale: navigator.language || 'en' });

createRoot(root).render(
  <StrictMode>
    {/* Its own store: an operator's session is not a restaurant's, and a
        restaurant's back office open in the next tab never sees it. */}
    <ApiProvider baseUrl="" storageKey="restaurant.platform.token">
      <Shell>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Shell>
    </ApiProvider>
  </StrictMode>,
);
